<div id="browser-message" *ngIf="isDesktop && isUnsupportedBrowser">
    <strong>{{ "browser-message.attention" | translate }}</strong>
    &nbsp;
    <span id="browser-translated-message" [innerHTML]="translation"></span>
</div>
